<script setup lang="ts">
interface HeaderToolProps {
    title: string;
    icon?: string;
    testIdPrefix?: string;
}

withDefaults(defineProps<HeaderToolProps>(), {
    testIdPrefix: "side-panel",
});
defineEmits<{ (e: "close"): void }>();
</script>

<template>
    <q-toolbar :data-qs="testIdPrefix ? `${testIdPrefix}-header-toolbar` : 'side-panel-header-toolbar'">
        <div v-if="icon" :data-qs="`${testIdPrefix}-panel-header-left-icon`" style="padding-right: 10px">
            <q-icon :name="icon" size="20px" />
        </div>
        <q-toolbar-title class="title">{{ title }}</q-toolbar-title>
        <q-icon
            :data-qs="`${testIdPrefix}-panel-header-close-icon`"
            size="20px"
            name="fa-regular fa-xmark icon-color cursor-pointer"
            @click="$emit('close')"
        />
    </q-toolbar>
</template>

<style lang="scss" scoped>
.title {
    color: $text-color-default;
    font-weight: $semi-bold;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    padding-left: 0;
}
</style>
